Controller = App.loadClass 'core::Angular/Controller'

class exports.EventsController extends Controller
    constructor: (
        @scope
        @transitions
        @modal
        @http
        @service
        @state
        @q
        @ngModal
    ) ->
        super

    addForm: (formType, fieldSurvey) =>
        @service.triggerBrowserWarning = false

        if formType is 'fertilizer'
            @ngModal.openFertilizerForm(fieldSurvey.fields_id, @service.year, null)
            .modalRef.result.then () =>
                @state.reload 'grower.nsolver'
            .catch _.noop
        else
            @state.go "grower.add-#{formType}",
                tab: 'plan'
                year: @service.year
                field_id: fieldSurvey.fields_id
                crop: @service.crop
                is_ingredion_field: false
                redirectId: @state.params.id
                redirectState: 'nsolver'
                step: @state.params.step

    editForm: (formType, fieldSurvey, forms = null) =>
        @service.triggerBrowserWarning = false

        forms ?= @formsByField formType, fieldSurvey
        if formType is 'fertilizer'
            afterForm = () =>
                if forms.length > 0
                    @editForm formType, fieldSurvey, forms
                else
                    @state.reload 'grower.nsolver'
            @ngModal.openFertilizerForm(fieldSurvey.fields_id, @service.year, { layers_id: forms.pop() })
                .modalRef
                .result
                .then afterForm
                .catch afterForm
        else
            @state.go "grower.view-#{formType}",
                id: forms[0]
                field: 0
                year: 0
                additionalIds: forms.slice(1)
                edit: true
                is_ingredion_field: false
                redirectId: @state.params.id
                redirectState: 'nsolver'
                step: @state.params.step

    eventsByField: (formType, fieldSurvey) =>
        fieldSurvey.events[formType]

    formsByField: (formType, fieldSurvey) =>
        _.uniq(@eventsByField(formType, fieldSurvey))
